import type { YoutubeApiResponse, YouTubeChannelSnippet } from './types';

export const searchYoutubeChannel = async (searchTerm: string) => {
  const res = await fetch(`/api/youtube/search?q=${searchTerm}`, {
    method: 'GET',
  });

  const json = await res.json();

  return json as YoutubeApiResponse;
};

export const findYoutubeChannel = async (channelID: string) => {
  const res = await fetch(`/api/safelist/channel-data?channelID=${channelID}`, {
    method: 'GET',
  });

  const json = await res.json();

  return json as YouTubeChannelSnippet;
};
